import { render } from "./CallServiceTimeRangesDoughnutChart.vue?vue&type=template&id=f4bbb108&ts=true"
import script from "./CallServiceTimeRangesDoughnutChart.vue?vue&type=script&lang=ts&setup=true"
export * from "./CallServiceTimeRangesDoughnutChart.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/CallServiceTimeRangesDoughnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f4bbb108"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f4bbb108', __exports__)) {
    api.reload('f4bbb108', __exports__)
  }
  
  module.hot.accept("./CallServiceTimeRangesDoughnutChart.vue?vue&type=template&id=f4bbb108&ts=true", () => {
    api.rerender('f4bbb108', render)
  })

}


export default __exports__